<div class="mt-3 cbsw-services-selection-step" role="region" aria-label="Service selection" id="service-selection-section" [attr.aria-busy]="showServiceGhostElement || showAdditionalServiceGhostElement">
  @if (showErrorMessage) {
    <div role="alert" aria-live="assertive" aria-atomic="true">
      <app-alert
        [isAlertMessageTranslated]="true"
        type="danger"
        message="error_messages.no_services_found_error"
      />
    </div>
  } @else if (showServiceGhostElement) {
    <ng-container *ngTemplateOutlet="ghostElementTemplate" role="status" aria-busy="true" aria-label="Loading services" />
  } @else if (servicesGroupedData?.length) {
    <div class="service-title" role="heading" aria-level="2">
      <app-csw-text
        customClass="step-element-title fw-600"
        [text]="serviceLabelTemplate | translation : 'template_content' : lang"
        [ariaLabel]="'Service selection title'"
      />
    </div>
    @for (serviceGroupedData of servicesGroupedData; track serviceGroupedData) {
      <div class="category-title" role="heading" aria-level="3">
        <app-csw-text
          [text]="serviceGroupedData?.temp?.appointment_service_category | translation : 'name' : lang | calioSafe : 'html'"
          customClass="fw-600 fs-13"
          [ariaLabel]="'Service category: ' + (serviceGroupedData?.temp?.appointment_service_category | translation : 'name' : lang)"
        />
      </div>
      @if (!widgetService?.widgetConf?.context?.show_appointment_services_list) {
        <swiper-container
          slides-per-view="2"
          space-between="20"
          free-mode="true"
          role="region"
          aria-label="Service carousel"
          aria-roledescription="carousel"
          aria-live="polite"
          [attr.aria-controls]="'service-carousel-controls'"
        >
          @for (serviceData of serviceGroupedData.value; track serviceData; let i = $index) {
            <swiper-slide
              role="group"
              [attr.aria-label]="'Slide ' + (i + 1) + ' of ' + serviceGroupedData.value.length"
              [attr.aria-roledescription]="'slide'"
              [attr.aria-selected]="isSelectedService(serviceData)"
              [attr.aria-controls]="'service-selection-section'"
            >
              <div class="mt-3">
                <ng-container *ngTemplateOutlet="serviceDataTemplate; context: { serviceData: serviceData }" />
              </div>
            </swiper-slide>
          }
        </swiper-container>
      }
      @if (widgetService?.widgetConf?.context?.show_appointment_services_list) {
        <div class="row service-list-container">
          @for (serviceData of serviceGroupedData.value; track serviceData) {
            <div class="col-md-6 mt-3">
              <ng-container *ngTemplateOutlet="serviceDataTemplate; context: { serviceData: serviceData }" />
            </div>
          }
        </div>
      }
    }

    @if (widgetService.widgetConf?.context?.show_additional_services_provided_by_meeting_providers?.length && bookingService.partnerData.allow_multiple_services_bookings !== 1) {
      <div class="mt-3 cbsw-additional-services-selection-step" role="region" aria-label="Additional services selection">
        @if (showAdditionalServiceGhostElement) {
          <ng-container *ngTemplateOutlet="ghostElementTemplate" role="status" aria-busy="true" aria-label="Loading additional services" />
        } @else if (additionalServicesGroupedData?.length) {
          <div class="service-title cbw-additional-service-title">
            <app-csw-text
              customClass="step-element-title fw-600"
              [text]="additionalServiceLabelTemplate | translation : 'template_content' : lang"
              [ariaLabel]="'Additional services title'"
            />
          </div>
          @for (serviceGroupedData of additionalServicesGroupedData; track serviceGroupedData) {
            <div class="category-title">
              <app-csw-text
                [text]="serviceGroupedData?.temp?.appointment_service_category | translation : 'name' : lang | calioSafe : 'html'"
                customClass="fw-600 fs-13"
                [ariaLabel]="'Additional service category: ' + (serviceGroupedData?.temp?.appointment_service_category | translation : 'name' : lang)"
              />
            </div>
            @if (!widgetService?.widgetConf?.context?.show_appointment_services_list) {
              <swiper-container
                slides-per-view="auto"
                space-between="20"
                free-mode="true"
                role="region"
                aria-label="Additional services carousel"
                aria-roledescription="carousel"
                aria-live="polite"
              >
                @for (serviceData of serviceGroupedData.value; track serviceData; let i = $index) {
                  <swiper-slide
                    role="group"
                    [attr.aria-label]="'Slide ' + (i + 1) + ' of ' + serviceGroupedData.value.length"
                    [attr.aria-roledescription]="'slide'"
                  >
                    <div class="mt-3">
                      <ng-container *ngTemplateOutlet="serviceDataTemplate; context: { serviceData: serviceData }" />
                    </div>
                  </swiper-slide>
                }
              </swiper-container>
            }
            @if (widgetService?.widgetConf?.context?.show_appointment_services_list) {
              <div class="row service-list-container">
                @for (serviceData of serviceGroupedData.value; track serviceData) {
                  <div class="col-md-6 mt-3">
                    <ng-container *ngTemplateOutlet="serviceDataTemplate; context: { serviceData: serviceData }" />
                  </div>
                }
              </div>
            }
          }
        }

      </div>
    }

    @if (showServiceSelectionRequiredError) {
      <div class="cbsw-meeting-type-selection-setp-error cbsw-global-step-error"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        [attr.aria-invalid]="true"
      >
        <div class="text-danger">
          <div>{{ 'error_messages.select_one_option' | translate }}</div>
        </div>
      </div>
    }

    <div class="d-flex justify-content-end mt-4 mb-4 pe-3 cbw-custom-navigation"
      role="navigation"
      aria-label="Service selection navigation"
      [attr.aria-controls]="'service-selection-section'"
    >
      <div class="me-2">
        <app-button
          id="services-selection-previous-btn"
          (clickEvent)="previous()"
          [fontColor]="widgetService?.widgetConf?.button_font_color"
          [backgroundColor]="widgetService?.widgetConf?.button_background_color"
          [ariaLabel]="'Go back to previous step'"
          [ariaControls]="'service-selection-section'"
        >
          <span class="custom-button-icon back" aria-hidden="true"></span>
          {{ bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_PREVIOUS_BUTTON, type: "template" } | translation : "template_content" : lang }}
        </app-button>
      </div>
      <div>
        <app-button
          id="services-selection-next-btn"
          (clickEvent)="next()"
          [fontColor]="widgetService?.widgetConf?.button_font_color"
          [backgroundColor]="widgetService?.widgetConf?.button_background_color"
          [ariaLabel]="'Continue to next step'"
          [ariaControls]="'service-selection-section'"
        >
          {{ bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_NEXT_BUTTON, type: "template" } | translation : "template_content" : lang }}
          <span class="custom-button-icon next" aria-hidden="true"></span>
        </app-button>
      </div>
    </div>
  } @else {
    <div class="alert alert-warning"
      role="alert"
      aria-live="polite"
      aria-atomic="true"
    >
      {{ 'error_messages.no_services_found' | translate }}
    </div>

    <div class="d-flex justify-content-end mt-4 mb-4 pe-3 cbw-custom-navigation">
      <app-button
        id="{{ 'services-selection-previous-btn' }}"
        (clickEvent)="previous()"
        [fontColor]="widgetService?.widgetConf?.button_font_color"
        [backgroundColor]="widgetService?.widgetConf?.button_background_color"
        [ariaLabel]="'Go back to previous step'"
        [ariaControls]="'service-selection-section'"
      >
        <span class="custom-button-icon back" aria-hidden="true"></span>
        {{ bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_PREVIOUS_BUTTON, type: "template" } | translation : "template_content" : lang }}
      </app-button>
    </div>
  }
</div>

<ng-template #serviceDataTemplate let-serviceData="serviceData">
  <app-info-card
    [showCursorPointer]="true"
    [showBody]="true"
    [showFooter]="true"
    [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
    [isSelected]="isSelectedService(serviceData)"
    (cardClickEvent)="toggleServiceSelection(serviceData)"
    role="button"
    [attr.aria-label]="(serviceData | translation: 'name': lang) + ' - ' + (serviceData | translation: 'description': lang)"
    [attr.aria-selected]="isSelectedService(serviceData)"
    [attr.aria-pressed]="isSelectedService(serviceData)"
    tabindex="0"
    [attr.aria-controls]="'service-selection-section'"
  >
    <div cardBody role="region" [attr.aria-label]="'Service details'">
      <div class="cbsw-service-name">
        <app-csw-text
          [text]="serviceData | translation : 'name' : lang | calioSafe : 'html'"
          customClass="fw-600 fs-13"
        />
      </div>
      @if (serviceData.description && bookingService.partnerData.show_inline_description === 1) {
        <div class="cbsw-service-description">
          <app-csw-text
            [text]="serviceData | translation : 'description' : lang"
            customClass="fs-13"
          />
        </div>
      }
      <div class="cbsw-service-duration">
        @if ((serviceData.duration | replaceComma | toHour) > 0) {
          <app-csw-text
            [text]="(serviceData.duration | replaceComma | toHour) + ('booking_components.durationHour' | translate)"
            customClass="fs-13"
          />
        }
        @if ((serviceData.duration | replaceComma | toMinute) > 0) {
          <app-csw-text
            [text]="(serviceData.duration | replaceComma | toMinute) + ('booking_components.durationMinute' | translate)"
            customClass="fs-13"
          />
        }
        @if (serviceData.price > 0) {
          <app-csw-text
            [text]="'/ ' + (serviceData.price | calioCurrency : bookingService.partnerData?.currency: lang)"
            customClass="fs-13"
          />
          @if (serviceData?.tax && serviceData?.tax?.rate >= 0) {
            <small class="taxes text-muted cbsw-taxes">
              ({{ 'booking_components.tax_info.' + bookingService.partnerData?.widget_vat_type | translate }}
                <span class="cbsw-taxes-percentage">{{ serviceData?.tax?.rate }}%</span>
                {{ 'booking_components.tax_info.taxes' | translate }})
            </small>
          }
        }
        @if (serviceData.price === 0) {
          {{ "booking_components.free" | translate }}
        }
      </div>

      @if (serviceData.meeting_provider_id && serviceData.is_additional_service) {
        <div class="cbsw-service-meeting-provider">
          @if (serviceData.meeting_provider_id === 1) {
            <app-csw-text [text]="'booking_components.consulting_in_store' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 2) {
            <app-csw-text [text]="'booking_components.consulting_via_zoom' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 3) {
            <app-csw-text [text]="'booking_components.consulting_via_calenso_meeting' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 4) {
            <app-csw-text [text]="'booking_components.consulting_via_phone' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 5) {
            <app-csw-text [text]="'booking_components.consulting_on_location' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 6) {
            <app-csw-text [text]="'booking_components.consulting_via_unblu' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 7) {
            <app-csw-text [text]="'booking_components.consulting_via_microsoft_teams' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 8) {
            <app-csw-text [text]="'booking_components.consulting_via_google_meet' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 9) {
            <app-csw-text [text]="'booking_components.consulting_via_goto_meeting' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 10) {
            <app-csw-text [text]="'booking_components.consulting_via_webex' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 11) {
            <app-csw-text [text]="'booking_components.consulting_via_phone' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 13) {
            <app-csw-text [text]="'booking_components.consulting_via_metaverse' | translate" customClass="fs-13" />
          } @else if (serviceData.meeting_provider_id === 15) {
            <app-csw-text [text]="'booking_components.consulting_via_kmeet' | translate" customClass="fs-13" />
          }
        </div>
      }

    </div>
    <div cardFooter>
      <div
        class="d-flex align-items-center justify-content-center"
        [ngClass]="{
          'justify-content-between': isSelectedService(serviceData)
        }"
      >
        <div class="d-flex align-items-center">
          @if (isSelectedService(serviceData)) {
            <app-csw-link
              [isLink]="false"
              [styleConfig]="{
                color: widgetService?.widgetConf?.header_background_color,
                textDecorationColor: widgetService?.widgetConf?.header_background_color
              }"
              [text]="'booking_components.deselect' | translate"
            />
          } @else {
            <app-csw-link
              [isLink]="false"
              [styleConfig]="{
                color: widgetService?.widgetConf?.header_background_color,
                textDecorationColor: widgetService?.widgetConf?.header_background_color
              }"
              [text]="'booking_components.select' | translate"
            />
          }
        </div>
        @if (isSelectedService(serviceData)) {
          <div class="next-arrow-container">
            <span (click)="next()">
              <img
                [src]="baseUrl + '/images/next_icon_widget.svg'"
                width="26px"
                alt="next_icon_widget"
              />
            </span>
          </div>
        }
      </div>
    </div>
  </app-info-card>
</ng-template>

<ng-template #ghostElementTemplate>
  <div
    class="skeleton-box-card"
    role="status"
    aria-live="polite"
    [attr.aria-label]="'Loading services'"
  >
    <div role="list" [attr.aria-label]="'Loading service options'">
      <div class="row">
        @for (ghostElement of serviceGhostElements; track $index) {
          <div class="col-md-6" role="listitem">
            <div
              class="d-flex stats-card shadow"
              role="presentation"
              [attr.aria-hidden]="true"
            >
              <div class="skeleton-animation w-100 d-flex justify-content-center align-items-start gap-3">
                <div>
                  <div class="bar bar-3"></div>
                </div>
                <div class="w-100 gap-3 d-flex flex-column">
                  <div class="bar bar-1"></div>
                  <div class="bar bar-2"></div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
